import createHistory from 'history/createBrowserHistory'

// Create a history (we're using a browser history in this case)

export default createHistory()
